<ng-container *ngTemplateOutlet="embedMode ? formBody : ''"></ng-container>
<p-dialog
  modal="true" [(visible)]="show"
  [closable]="false"
  [minY]="350"
  styleClass="atlas-dialog-m"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    <h4 style="font-weight: normal">
      {{ 'profiles.view.add-member.add-new-member' | translate | titlecase }}
    </h4>
  </ng-template>
  <ng-container *ngTemplateOutlet="!embedMode ? formBody : ''"></ng-container>
  <ng-template pTemplate="footer">
    <!-- Footer -->
    <button pButton type="button" class="atlas-btn atlas-btn-default" (click)="close.emit()">{{ 'common.cancel' | translate | uppercase }}</button>
    <button pButton type="button" class="btn btn-primary" (click)="save()" [disabled]="isSaving || !canSave">
      <span *ngIf="!isSaving">{{ 'profiles.view.add-member.save-and-close' | translate | uppercase }}</span>
      <wl-busy [show]="isSaving"></wl-busy>
    </button>
    <button pButton type="button" class="btn btn-primary" (click)="saveAndContinueEditing()" [disabled]="isSaving || !canSave">
      <span *ngIf="!isSaving">
        {{ 'profiles.view.add-member.continue-editing' | translate | uppercase }}
        <i class="pi pi-angle-double-right"></i>
      </span>
      <wl-busy [show]="isSaving"></wl-busy>
    </button>
  </ng-template>
</p-dialog>

<ng-template #formBody>
  <div>
    <wl-profile-type-icon
      [isMember]="isMember"
      [isOrg]="profile.OrgInd"
      [profileId]="profile.ProfileId"
      [styleOverrides]="{ 'max-width': '34px', 'max-height': '34px' }"
      class="p-20"
    ></wl-profile-type-icon
    ><strong>{{ profile.ReportName }}</strong>
    <hr />
  </div>

  <div class="mv-14">
    <p-checkbox [(ngModel)]="isMember" binary="true" name="member"  inputId="chk_uyu5j0"></p-checkbox>
<label for="chk_uyu5j0">Member</label>
  </div>

  <div class="mv-14 mct-flex mct-col"  [ngClass]="{ disabled: !isMember }">
    <label class="required">{{ 'profiles.view.add-member.member-activity-label' | translate | titlecase }}</label>
    <p-select
      [required]="true"
      appendTo="body"
      placeholder="-- Select -- "
      [options]="memberActivityTypes"
      [disabled]="!isMember"
      [style]="{ width: '100%' }"
      [(ngModel)]="selectedActivityType.ActivityTypeID"
    ></p-select>
  </div>

  <div class="mv-14 mct-flex mct-col"  [ngClass]="{ disabled: !isMember }">
    <label>{{ 'profiles.view.add-member.member-activity-date-label' | translate | titlecase }}</label>
    <wl-date-selector
      appendTo="body"
      [(ngModel)]="selectedActivityDate"
      (onDateChanged)="dateSelected($event)"
      [disabled]="!isMember"
    ></wl-date-selector>
  </div>

  <div class="mt-40 mct-flex mct-col"  [ngClass]="{ disabled: !isMember }">
    <label>{{ 'profiles.view.add-member.membership-level-label' | translate | titlecase }}</label>
    <p-select
      appendTo="body"
      optionLabel="Name"
      dataKey="MembershipLevelId"
      placeholder="-- Select -- "
      [options]="membershipLevels"
      [style]="{ width: '100%' }"
      [disabled]="!isMember"
      [(ngModel)]="selectedMembershipLevel"
    ></p-select>
  </div>

  <div class="mt-27">
    <p>{{ 'profiles.view.add-member.membership-level-setting-info' | translate }}</p>
  </div>
</ng-template>
